interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  padding?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md', padding = 'md' }) => {
  const sizeClasses = {
    sm: 'h-16',
    md: 'h-48',
    lg: 'h-64'
  };

  const paddingClasses = {
    none: 'p-0',
    xs: 'p-1',
    sm: 'p-2',
    md: 'p-4',
    lg: 'p-8',
    xl: 'p-12'
  };

  return (
    <img
      src="/logo.png"
      alt="Logo"
      className={`${sizeClasses[size]} w-auto max-w-full object-contain ${paddingClasses[padding]} ${className}`}
    />
  );
};

export default Logo;
